import { useQuery } from '@tanstack/react-query';
import { getProfessionalAttestation } from '../../../../services/credentials';

export const useFetchProfessionalDsoAttestation = (userId, attestationCode) => {
  const { data, isLoading } = useQuery({
    queryKey: ['getProfessionalAttestation', `${userId}-${attestationCode}`],
    queryFn: () => getProfessionalAttestation(userId, attestationCode),
  });

  return { data: data?.data?.data || null, isLoading };
};
